export const getInputsIds = (formSchema = {}) => {
  let allInputs = [];
  if (!formSchema?.schema) return [];
  if (Object.keys(formSchema?.schema).length > 0) {
    const { sections } = formSchema.schema.layout;
    sections.forEach((l) => {
      l.rows.forEach((r) => {
        const newInputs = r.cols.map((col) => col.fieldId);
        allInputs = [...allInputs, ...newInputs,];
      });
    });
    return allInputs;
  }
};

export const getInputsIdsLabels = (formSchema = {}) => {
  const allInputs = {};
  if (!formSchema?.schema) return [];
  if (Object.keys(formSchema?.schema).length > 0) {
    const { sections } = formSchema.schema.layout;
    
    sections.forEach((l) => {
      l.rows.forEach((r) => {
        r.cols
        .filter((col) => col.type !== 'file' || col.type !== 'camera')
        .forEach((col) => {
          allInputs[col.fieldId] = col?.props?.label
        });
      });
    });
    return allInputs;
  }
};

const getFieldKey = props => {
  const myArr = [];
  if (isNaN(props.duplicateSectionNumber)) myArr.push(props.duplicateSectionNumber)
  if (isNaN(props.duplicateRowNumber)) myArr.push(props.duplicateRowNumber)
  myArr.push(props.fieldId)
  return myArr.filter(a => a).join('-');
}

export const processForm = (formSchema = {}, duplicateFields = {}) => {
  if (!formSchema?.schema) return [];
  if (Object.keys(formSchema?.schema).length > 0) {
    const { sections } = formSchema.schema.layout;
    const candidateInfo = [];
    sections.forEach((sect) => {
      const secRows = !Array.isArray(sect.rows) ? [sect.rows] : sect.rows;
      const duplicateSecIds = duplicateFields?.sections?.[sect.id] || [];
      const newSecs = [
        { id: sect.id, rows: secRows },
        ...duplicateSecIds.map((id, index) => ({ id, sectionNumber: index + 1, rows: [...secRows] })),
      ];
      newSecs.forEach(l => {
        const currentSection = {};
        const sectionNumber = l.sectionNumber ? ` (${l.sectionNumber})` : '';
        currentSection.title = `${sect.title}${sectionNumber}`;
        currentSection.description = l.description;

        l.rows.forEach((r) => {
          const cls = !Array.isArray(r.cols) ? [r.cols] : r.cols;

          const duplicateRowIds = duplicateFields?.rows?.[`${l.id}-${r.id}`] || [];
          const newRows = [
            { id: r.id, cols: cls },
            ...duplicateRowIds.map((id, index) => ({ id, rowNumber: index + 1, cols: [...cls] })),
          ];

          newRows.forEach(rw => {
            const newInputs = rw.cols
              .filter(col => col.type !== 'file' && col.type !== 'camera' && col.props.label)
              .map((col) => {
                const rowNumber = rw.rowNumber ? ` (${rw.rowNumber})` : '';
                return ({
                  id: getFieldKey({ duplicateSectionNumber: l.id, duplicateRowNumber: rw.id, fieldId: col.fieldId }),
                  title: `${col.props.label}${rowNumber}`,
                  type: col.type,
                  source: col?.props?.source,
                })
              });
            currentSection.inputs = [
              ...(currentSection.inputs || []),
              newInputs,
            ];
          })
        });
        currentSection.inputs = currentSection.inputs?.filter(i => i?.length > 0);
        candidateInfo.push(currentSection);
      })
    });
    return candidateInfo;
  }
};

export const processFormFiles = (formSchema = {}, df = {}) => {
  if (!formSchema?.schema) return [];
  if (Object.keys(formSchema?.schema).length > 0) {
    const { sections } = formSchema.schema.layout;
    let candidateFiles = [];
    sections.forEach((sect) => {
      const secRows = !Array.isArray(sect.rows) ? [sect.rows] : sect.rows;
      const duplicateSecIds = df?.sections?.[sect.id] || [];
      const newSecs = [
      { ...sect, rows: secRows },
      ...duplicateSecIds.map((id, index) => ({
        ...sect,
        id,
        sectionNumber: index + 1,
        rows: [...secRows],
      })),
    ];
    newSecs.forEach((l) => {
      l.rows.forEach((r) => {

        const cls = !Array.isArray(r.cols) ? [r.cols] : r.cols;

        const duplicateRowIds =
        df?.rows?.[`${l.id}-${r.id}`] || [];
        const newRows = [
          { id: r.id, cols: cls },
          ...duplicateRowIds.map((id, index) => ({
            id,
            rowNumber: index + 1,
            cols: [...cls],
          })),
        ];

        newRows.forEach((rw) => {
          const newInputs = rw.cols
            .filter((col) => col.type === 'file' || col.type === 'camera')
            .map((col) => {
              const rowNumber = rw.rowNumber ? ` (${rw.rowNumber})` : '';
              
              return {
                id: getFieldKey({
                  duplicateSectionNumber: l.id,
                  duplicateRowNumber: rw.id,
                  fieldId: col.fieldId,
                }),
              title: `${col.props.label}${rowNumber}`,
              section: l.title,
              sectionDescription: l.description,
              alternateLabel: col.props.alternateLabel || col.props.label,
              type: col.type,
            }});
          candidateFiles = [...candidateFiles, ...newInputs];
        });
      })
    })
    });
    return candidateFiles;
  }
};

export const getColumnStructure = (len) => {
  const colStructure = Array.from(len).map(() => '1fr').join(' ');
  return colStructure;
};

export const formatAddress = (val) => {
  if (typeof (val) === 'string') return val;
  return (val || [])?.reverse()?.join(' LGA of ')
}
